import React, { Component } from 'react';
import {resolveVariables} from 'functions';
import {TextInput, CSSInput} from 'library';

class Span extends React.Component {
    static component_name = 'Span';
    constructor(props) {
        super(props);
        this.config = {
            form_components: [
                <TextInput label={'text'} name={'text'} default={'Default Text'} />,
                <TextInput label={'Tooltip Title'} name={'title'} default={'Default Text'} />,
                <TextInput label={'class'} name={'className'} default={'Default Text'} />,
                <CSSInput label={'css'} name={'style'} default={{}} />
            ],
        }
    }

    render() {
        return (
            <span className={this.props.className} title={this.props.title} style={this.props.style || {}}>{this.props.text}</span>
        );
    }
}

export default Span;
